export default "__VITE_ASSET__7b950dad__"